import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/modules/settings/selectors";
import messages from "rdx/modules/settings/messages";
import { keysToCamelCase } from "lib/helpers";

function* createAdminBatteryServiceArea(action) {
  const { success, data, error } = yield* makeRequest.post("/battery_service_areas", action.payload);

  if (success && data) {
    const serviceAreas = yield select(selectors.getAdminBatteryServiceAreas);
    const newArea = keysToCamelCase(data.body);
    yield all([
      put(actions.setAdminBatteryServiceAreas([...serviceAreas, newArea])),
      put(
        actions.newSuccessEvent({
          message: messages.BATTERY_SERVICE_AREA_CREATE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_BATTERY_SERVICE_AREA,
    });
  }

  return null;
}

export default createAdminBatteryServiceArea;
